<template>
  <v-layout wrap>
    <v-container class="pa-6">
      <v-flex sm12>
        <h1 class="primary--text">Captura masiva</h1>
      </v-flex>
      <v-form ref="form" @submit.prevent="send">
        <v-flex sm12>
          <v-autocomplete
            autocomplete="false"
            v-model="participant"
            :items="participants"
            :loading="isLoading"
            :rules="requiredRule"
            required
            color="grey"
            hide-no-data
            hide-selected
            item-text="work"
            label="Buscar empleados"
            prepend-icon="mdi-database-search"
            return-object
          >
            <template v-slot:item="{ item }">
              <v-list-item-avatar
                color="indigo"
                class="headline font-weight-light white--text"
              >{{ item.name.charAt(0) }}</v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle v-text="item.work"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex sm4 offset-sm4>
          <v-btn type="submit" class="primary" block>Continuar</v-btn>
        </v-flex>
      </v-form>

      <v-snackbar v-model="snackbar" right top :timeout="3000">
        {{ message }}
        <v-btn color="blue" text @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      snackbar: false,
      message: "",
      participant: {},
      participants: [],
      isLoading: false,
      search: "",
      requiredRule: [v => !!v || "Este campo es obligatorio"],

      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      if (this.$refs.form.validate() && this.participant.name != null) {
        if (this.participant.resolved) {
          this.message = "El empleado ya ha resuelto el cuestionario";
          this.snackbar = true;
        } else {
          sessionStorage.setItem(
            "clientParticipant",
            JSON.stringify(this.participant)
          );
          this.$router.push({
            name: "massivepersonaldata"
          });
        }
      } else {
        this.message = "Asegurate de seleccionar un empleado";
        this.snackbar = true;
      }
    },
    getParticipants() {
      let data = {
        idUser: sessionStorage.getItem("authorization")
      };
      this.isLoading = true;
      axios
        .post(this.host + "/participants/read.php", this.createFormData(data))
        .then(response => {
          this.participants = response.data.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getParticipants();
  }
};
</script>